import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PRESALE_LAUNCH } from "@/lib/presale";
import { BuyPinkSaleButton } from "@/components/BuyPinkSaleButton";

function getRemaining(target) {
  const diff = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds, done: diff === 0 };
}

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [t, setT] = useState(getRemaining(PRESALE_LAUNCH));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(PRESALE_LAUNCH)), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: pad(t.hours) },
    { label: "Minutes", value: pad(t.minutes) },
    { label: "Seconds", value: pad(t.seconds) },
  ];

  return (
    <div data-testid="presale-countdown" className="text-center">
      {t.done ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          data-testid="presale-live-banner"
          className="mx-auto max-w-2xl border border-ember/50 bg-gradient-to-br from-ember/15 via-background to-background p-8 sm:p-10"
        >
          <div className="flex items-center justify-center gap-2 text-ember">
            <motion.span
              animate={{ opacity: [1, 0.4, 1] }}
              transition={{ duration: 1.4, repeat: Infinity }}
              className="inline-block w-2.5 h-2.5 rounded-full bg-ember"
            />
            <span className="font-mono text-xs uppercase tracking-[0.25em]">Live Now</span>
          </div>
          <h3 className="mt-4 font-display font-bold text-3xl sm:text-4xl">
            The $AFTBRN Presale is <span className="text-ember ember-text-glow">LIVE</span> 🔥
          </h3>
          <p className="mt-3 text-muted-foreground">
            Secure your spot in the regrowth. Contribute now on PinkSale.
          </p>
          <div className="mt-6 flex justify-center">
            <BuyPinkSaleButton
              testId="presale-live-buy-btn"
              label="Buy $AFTBRN Now"
              className="group inline-flex items-center justify-center gap-2 bg-ember text-black font-bold px-10 py-4 text-lg hover:bg-ember-light transition-colors"
            />
          </div>
        </motion.div>
      ) : (
        <>
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-ember">
            Presale opens in
          </span>
          <div className="mt-5 flex justify-center gap-3 sm:gap-5">
            {units.map((u, i) => (
              <motion.div
                key={u.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="bg-card border border-white/10 w-20 sm:w-28 py-4 sm:py-6"
                data-testid={`countdown-${u.label.toLowerCase()}`}
              >
                <div className="font-display font-bold text-3xl sm:text-5xl text-ember tabular-nums">
                  {u.value}
                </div>
                <div className="mt-1 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground">
                  {u.label}
                </div>
              </motion.div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
